import { render, staticRenderFns } from "./diagram-view-area-browser.component.vue?vue&type=template&id=4b8910c4"
import script from "./diagram-view-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./diagram-view-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./diagram-view-area-browser.component.vue?vue&type=style&index=0&id=4b8910c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports